import {AppConfig, EnvType} from "../../appConf";

export enum Api {
    auth = "officePal_API/Api/Auth?name=mdland_health",
    appointmentInfo = "officePal/FrontIn/AppointmentJson/",
    getModByPatientID = "officePal_API/Api/PatientSign/GetModByPatientID",
    getPatientByTokenID = "officePal_API/Api/PatientSign/GetPatientByTokenID",
    updatePatient2= "officePal_API/Api/SignIn/UpdatePatient2",
    getUpdatePatient3= "officePal_API/Api/SignIn/GetUpdatePatient3",
    getLocationById= "officePal_API/Api/Location/GetLocationById",
    signatureFinishApi= "officePal/FrontIn/SignatureFinishApi",
    checkin = "officePal/FrontDesk/SaveConfirm/",
    getCheckInStatus = "officePal/FrontDesk/GetConfirmStatus/",
}

enum APIBaseUrl {
    dev = "https://mdlandawsdev.mdland.net/",
    uat = "",
    pro = "",
}

export const GetAPIHost = () => {
    if (AppConfig.envType === EnvType.dev) {
        return APIBaseUrl.dev
    } else if (AppConfig.envType === EnvType.uat) {
        return APIBaseUrl.uat
    }
    return APIBaseUrl.pro
}

export const GetAPIBaseURLByService = () => {
    return window.location.href.includes("localhost") ? "" : GetAPIHost()
}
